import { styled } from '@mui/material';
import Button from '@mui/material/Button';

const PatientConsultationDetailsButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  width: '100%',
  maxWidth: '178px',
}));

export { PatientConsultationDetailsButton };
